import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { RegUser } from 'src/app/pages/basic-reg/RegUser';


import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';

@Component({
  selector: 'app-thanks-for-reg',
  templateUrl: './thanks-for-reg.component.html',
  styleUrls: ['./thanks-for-reg.component.scss'],
  standalone: true,
  imports: [CommonModule, IonicModule]
})
export class ThanksForRegComponent implements OnInit {

  @Input("user") user!: RegUser;

  constructor(private modalCtrl:ModalController) {}

  async dismiss() {
    this.modalCtrl.dismiss();
  }

  ngOnInit(): void {
  }

}
